import React from 'react';
import styles from './style.module.css';

const Button = ({
  children,
  variant = 'filled', // 'filled' | 'outline'
  color = 'primary', // 'primary' | 'accent' | 'gray' | 'danger'
  startIcon,
  endIcon,
  radius = 'pill', // 'pill' | 'rounded' | 'soft'
  size = 'md', // 'sm' | 'md' | 'lg'
  onClick,
  className = '',
  disabled = false,
  ...rest
}) => {
  const cls = [
    styles.btn,
    styles[variant],
    styles[color],
    styles[radius],
    styles[size],
    disabled ? styles.disabled : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={cls} onClick={onClick} disabled={disabled} {...rest}>
      {startIcon && <span className={`${styles.icon} ${styles.start}`}>{startIcon}</span>}
      <span className={styles.label}>{children}</span>
      {endIcon && <span className={`${styles.icon} ${styles.end}`}>{endIcon}</span>}
    </button>
  );
};

export default Button;
